import { Link } from "../router";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className={`brand ${compact ? "brand--compact" : ""}`} href="/admin">
      <span className="brand-mark" aria-hidden="true"><span /></span>
      <span>
        Leviathan
        <small>Proposal studio</small>
      </span>
    </Link>
  );
}
